import { render, staticRenderFns } from "./Branchs.vue?vue&type=template&id=220f3e38&"
import script from "./Branchs.vue?vue&type=script&lang=js&"
export * from "./Branchs.vue?vue&type=script&lang=js&"
import style0 from "./Branchs.vue?vue&type=style&index=0&id=220f3e38&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports